import { render, staticRenderFns } from "./PizzaChartAbandoned.vue?vue&type=template&id=c341d858"
import script from "./PizzaChartAbandoned.vue?vue&type=script&lang=js"
export * from "./PizzaChartAbandoned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports